import { render } from "./AssemblyPage.vue?vue&type=template&id=cf7b9032&scoped=true"
import script from "./AssemblyPage.vue?vue&type=script&lang=js"
export * from "./AssemblyPage.vue?vue&type=script&lang=js"

import "./AssemblyPage.vue?vue&type=style&index=0&id=cf7b9032&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf7b9032"]])

export default __exports__